var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":""}},[_c('v-img',{attrs:{"contain":"","max-height":_vm.size,"max-width":_vm.size,"src":_vm.getSrc('Loading-Blue.gif')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }